import { integer } from 'vuelidate/lib/validators';

export default {
    integer
};